import { Component, QueryList, ViewChildren } from '@angular/core';
import { TABLAEJECUTADAS, tablaEjecutadas } from '../../../../shared/data/tables/tabla-ejecutadas';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { TableService } from '../../../../shared/services/table-ejecutadas';
import { Observable } from 'rxjs';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ejecutadas',
  templateUrl: './ejecutadas.component.html',
  styleUrls: ['./ejecutadas.component.scss']
})
export class EjecutadasComponent {
  // Variables for date range
  model: NgbDateStruct;
  date: { year: number; month: number };
  displayMonths = 2;
  navigation = "select";
  showWeekNumbers = false;
  outsideDays = "visible";
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  model2: NgbDateStruct;
  placement = "top";

  // Other variables
  public isCollapsed = true;
  public selected = [];
  public searchText: string = "";  // Variable for search input
  public filteredTableItems: tablaEjecutadas[] = [];

  // Table data and service
  public tableItem$: Observable<tablaEjecutadas[]>;
  public total$: Observable<number>;

  // Services options
  public servicios = [
    { value: "1", label: "Servicio 1", job: "Developer" },
    { value: "2", label: "Servicio 2", job: "Developer" },
    { value: "3", label: "Servicio 3", job: "Developer" },
  ];

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  // Constructor to initialize the component
  constructor(
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter, 
    private service: TableService
  ) {
    // Initialize table data and set user data
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(TABLAEJECUTADAS); // Set the data for the table

    // Initialize date range
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }

  ngOnInit() {
    // Filter table items initially
    this.filterByMultipleFields();
  }

  // Method to handle date selection
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  // Helper methods for date range logic
  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  // Validate the date input
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  // Sort method for the table
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  // Method to delete table data
  deleteData(id: number) {
    this.tableItem$.subscribe((data: any) => {
      data.map((elem: any, i: number) => {
        if (elem.id === id) {
          data.splice(i, 1);
        }
      });
    });
  }

  // Function to filter by multiple fields
  filterByMultipleFields() {
    const searchTerm = this.searchText.toLowerCase();
    this.filteredTableItems = TABLAEJECUTADAS.filter(item =>
      item.Enviado.toLowerCase().includes(searchTerm) ||
      item.Estado.toLowerCase().includes(searchTerm) ||
      item.Fecha.toLowerCase().includes(searchTerm) ||
      item.Hora.toLowerCase().includes(searchTerm) ||
      item.Nombre.toLowerCase().includes(searchTerm) ||
      item.id.toLowerCase().includes(searchTerm)
    );
  }

  // Method to handle the search input
  onSearch(event: any) {
    this.searchText = event.target.value;
    this.filterByMultipleFields();  // Call filter function when search text changes
  }
}
